// Libraries
var React = require('react');

// Styles
require('./MembershipItem.scss');

// Components
var CallToAction = require('../../common/CallToAction/CallToAction');

class MembershipItem extends React.Component {
	render() {
		const images = this.props.membership.image;

		return (
			<div className="MembershipItem">
				<div className="MembershipItem__image" ref={(image) => { this.image = image; }} data-bg={images.smallUrl + '*,*' + images.mediumUrl + '*,*' + images.largeUrl + '*,*' + images.extraLargeUrl}>
				</div>
				<div className="MembershipItem__details">
					<p className="text--highlight">{this.props.membership.name}</p>
					<p>{this.props.membership.ageGroupDescription ? this.props.membership.ageGroupDescription : '\u00A0'}</p>
					<div className="MembershipItem__details--left">
						<p className="text--highlight">{this.props.membership.priceDescription}</p>
						<p className="text--subtle">{this.props.membership.alternativePaymentDescription}</p>
					</div>
					<div className="MembershipItem__details--right">
						<p className="text--highlight large">{this.props.membership.formattedPrice}</p>
						<p className="text--subtle">{this.props.membership.formattedAlternativePaymentPrice}</p>
					</div>
				</div>
				<div className="MembershipItem__cta">
					<CallToAction button={true} {...this.props.membership.primaryLink} />
				</div>
				{this.props.membership.secondaryLink &&
					<a href={this.props.membership.secondaryLink.url} className="secondary" target={this.props.newWindow ? "_blank" : "_self"} rel={this.props.newWindow ? "noopener noreferrer" : undefined}>{this.props.membership.secondaryLink.caption}</a>
				}
			</div>
		)
	}
}

module.exports = MembershipItem;



// WEBPACK FOOTER //
// ./src/components/Membership/MembershipItem.js